/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeEvent, ReactNode, useEffect, useState } from 'react';
import {
  FlexContainer,
  Input,
  InputDatePicker,
  Button,
} from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { DownloadWrapper, TableOptionsStyles } from './Styles';
import { useOperations } from '../../providers';
import { OrderBy } from '../../state/constants';

type DateRange = {
  from: Date | null;
  to: Date | null;
};

export type OptionsType = {
  limit?: number;
  fromTimestamp?: string;
  text?: string;
  toTimestamp?: string;
  orderBy?: string;
};

type TableOptionsProps = {
  values?: OptionsType;
  onChange?(value: OptionsType): void;
  children?: ReactNode;
  filterComponent?: ReactNode;
  onDownload?(option?: boolean): Promise<void>;
  text?: string | undefined;
  setText(value: any): void;
  date?: DateRange | undefined;
  setDate(value: any): void;
};

export const TableOptions = ({
  onChange,
  children,
  filterComponent,
  text,
  setText,
  date,
  setDate,
  onDownload,
}: TableOptionsProps) => {
  const { t } = useTranslation();
  const { showDownload } = useOperations();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const handleText = (e: ChangeEvent<HTMLInputElement>) =>
    setText(e.target.value);

  const handleDate = (value: DateRange | undefined) => {
    setDate(value);
  };

  useEffect(() => {
    if (date || text) {
      onChange &&
        onChange({
          text: text || undefined,
          fromTimestamp: date?.from?.toISOString(),
          toTimestamp: date?.to?.toISOString(),
          orderBy: OrderBy.lastUpdateTime,
        });
    }
  }, [date, text]);

  const startDownload = () => {
    if (onDownload) {
      setLoading(true);
      onDownload().finally(() => setLoading(false));
    }
  };

  return (
    <TableOptionsStyles alignItems="center" columnGap="2.4">
      <div>
        <FlexContainer data-tour="filter-1">
          <InputDatePicker
            className="date-picker"
            maxDate={new Date()}
            value={date as any}
            onChange={handleDate as any}
            isRange={true}
          />
        </FlexContainer>
        <Input
          type="text"
          iconLeft="MagnifyingGlass"
          onChange={handleText}
          value={text}
          placeholder={t('User ID')}
          testId={'input-search'}
        />
        <FlexContainer data-tour="filter-2">{filterComponent}</FlexContainer>
      </div>
      <DownloadWrapper>
        {children}
        {showDownload &&
          onDownload &&
          location.pathname.includes('operations') && (
            <Button
              iconName="DownloadSimple"
              onClick={startDownload}
              testId="download-operations"
              color="primary"
              className={loading ? 'infinite-loading' : ''}
              disabled={loading}
            >
              {t('Generate report')}
            </Button>
          )}
      </DownloadWrapper>
    </TableOptionsStyles>
  );
};
